import React, { useState, useRef, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
// mui
import { useTheme } from "@mui/styles";
import Box from "@mui/material/Box";

export default function MapTeaser() {
  const theme = useTheme();
  return (
    <Box sx={{ margin: theme.spacing(5, 0) }}>
      <Link passHref href={`/listings`}>
        <Box
          sx={{
            position: "relative",
            margin: "8% auto 1% auto",
            width: "100%",
            height: "500px",
            "& div:hover": {
              boxShadow: `0 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 15px 3px ${process.env.fuchsia}`,
              transition: `all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)`,
              cursor: "pointer",
            },
            [theme.breakpoints.down("md")]: {
              display: "none",
            },
          }}
        >
          <Box
            sx={{
              fontFamily: `"Neue haas unica pro", sans-serif`,
              fontSize: "70px",
              top: "200px",
              left: "45px",
              position: "absolute",
              color: "white !important",
              zIndex: 2,
              borderRadius: "4px",
              padding: "8px",

              [theme.breakpoints.down("md")]: {
                textAlign: "center",
                position: "relative",
                fontSize: "35px",
                background: `linear-gradient(90deg,#ff00ff,1%,${process.env.primaryBrandColor})`,
                width: "100%",
                left: "0px",
                top: "0px",
              },
            }}
          >
            Off-market deals
          </Box>
          <Box
            sx={{
              position: "relative",
              height: "100%",
              overflow: "hidden",
              [theme.breakpoints.down("md")]: {
                height: "90%",
              },
            }}
          >
            <Image src={"/all-map-2.jpg"} layout="fill" objectFit={"cover"} />
          </Box>
        </Box>
      </Link>
      <Link passHref href={`/listings`}>
        <Box
          sx={{
            display: "none",
            [theme.breakpoints.down("md")]: {
              display: "block",
              margin: "8% auto 1% auto",
              width: "100%",
              position: "relative",
              height: "250px",
            },
          }}
        >
          <Box
            sx={{
              fontFamily: `"Neue haas unica pro", sans-serif`,
              fontSize: "70px",
              top: "200px",
              left: "45px",
              position: "absolute",
              color: "white !important",
              zIndex: 2,

              [theme.breakpoints.down("md")]: {
                textAlign: "center",
                position: "relative",
                fontSize: "35px",
                background: `linear-gradient(90deg,#ff00ff,1%,${process.env.primaryBrandColor})`,
                width: "100%",
                left: "0px",
                top: "0px",
              },
            }}
          >
            Off-market deals
          </Box>
          <Box
            sx={{
              position: "relative",
              height: "100%",
              overflow: "hidden",
              [theme.breakpoints.down("md")]: {
                height: "90%",
              },
            }}
          >
            <Image src={"/whole-map.jpg"} layout="fill" objectFit={"cover"} />
          </Box>
        </Box>
      </Link>
    </Box>
  );
}
